export default __webpack_public_path__ + "static/media/gallery_09.9bab629b.jpg";